import { selectFromProjectDto } from '../../models';

export default selectFromProjectDto()
  .id
  .name
  .createdOn
  .startDate
  .source
  .organizationId
  .visitGeocodingCount
  .isSynced
  .pendingSolutions(pendingSolution => pendingSolution
    .id
    .actionType
    .assignAction(assignAction => assignAction
      .id
      .visitId
      .visitName
      .targetRouteId
      .targetRouteName
      .details(details => details
        .eventUuids
        .routeUuids)))
  .toString();
